import { post } from "./axiosServices";
// @utils
import { poolData, urlbase } from "../../config";

import { navigate } from "gatsby";
import { getPathname, getStorage } from "../utils/utils";
import { getPermissions } from "./appServices";

// @Conexion cognito Identity
const AmazonCognitoIdentity = require("amazon-cognito-identity-js");
// @Conexion al grupo de usuarios
const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData());

const apiGetWay = `${urlbase}/user-exists`;
const moment = require("moment");

export const getUser = async (data) => {
  try {
    return post(apiGetWay, data);
  } catch (error) {
    return null;
  }

};

const apiCreateUser = `${urlbase}/users`;
export const userUtils = async (data, token) => {
  try {
    return post(apiCreateUser, data, token);
  } catch (error) {
    return null;
  }
};

export const refreshSession = async (setUser, setDirectivas, setRecursos, setIsView, setNotifications) => {
  const userLogin = new AmazonCognitoIdentity.CognitoUserPool(poolData());
  const user = await userLogin.getCurrentUser();
  if (user) {
    user.getSession(async (err, result) => {
      if (err) {
      }
      if (result) {
        const RefreshToken = new AmazonCognitoIdentity.CognitoRefreshToken({
          RefreshToken: result.refreshToken.token,
        });
        user.refreshSession(RefreshToken, async (err, session) => {
          if (err) throw err;
          const permisos = await getPermissions(result.accessToken.jwtToken);
          const usuario = await userUtils(
            {
              option: "getUser",
              data: {
                username: result.accessToken.payload.username,
              },
            },
            result.accessToken.jwtToken
          );
          if (usuario) {
            Object.keys(result.idToken.payload).forEach((e) => {
              usuario.Attributes.forEach((at) => {
                if (at.Name == e) {
                  result.idToken.payload[e] = at.Value;
                }
              });
            });
          }
          setUser({
            group: session.idToken.payload["cognito:groups"]
              ? session.idToken.payload["cognito:groups"][0]
              : "",
            token: result.accessToken.jwtToken,
            ...session.idToken.payload,
          });
          const storage = getStorage('items', true);
          if (storage) {
            const findStorage = storage.find((e) => e.username === usuario.Username)
            if (findStorage) {
              setNotifications(findStorage.cantidad);
              setIsView(findStorage.views);
            } else {
              setNotifications(0);
              setIsView(true)
            }
          }
          if (permisos) {
            setDirectivas(permisos.directivas);
            setRecursos(permisos.recursos);
          }
        });
      }
    });
  }
};

export const handleExpiracion = (result) => {
  if (result) {
    const moment_expiration = moment.unix(result);
    const isExpired = moment_expiration.isSameOrAfter(moment());
    return isExpired;
  } else {
    return false;
  }
};

export const validateSession = async (
  setIsLogged,
  setUser,
  setDirectivas,
  setRecursos,
  setIsView,
  setNotifications
) => {
  const pathname = getPathname();
  if (
    pathname &&
    (pathname.includes("login") || pathname.includes("actualizar-contrasena") || pathname.includes("codigo") || pathname.includes("verificar-MFA") || pathname.includes("seleccionar-mfa"))
  ) {
    return;
  }
  const userLogin = new AmazonCognitoIdentity.CognitoUserPool(poolData());
  const user = await userLogin.getCurrentUser();
  if (user) {
    user.getSession(async (err, result) => {
      if (err) {
        setIsLogged(false);
        navigate("/login");
      }
      if (result) {
        if (handleExpiracion(result.accessToken.payload.exp)) {
          const permisos = await getPermissions(result.accessToken.jwtToken);
          const usuario = await userUtils(
            {
              option: "getUser",
              data: {
                username: result.accessToken.payload.username,
              },
            },
            result.accessToken.jwtToken
          );
          if (usuario) {
            Object.keys(result.idToken.payload).forEach((e) => {
              usuario.Attributes.forEach((at) => {
                if (at.Name == e) {
                  result.idToken.payload[e] = at.Value;
                }
              });
            });
          }
          sessionStorage.setItem("email", result.idToken.payload.email);
          setUser({
            group: result.idToken.payload["cognito:groups"]
              ? result.idToken.payload["cognito:groups"][0]
              : "",
            ...result.idToken.payload,
            token: result.accessToken.jwtToken,
          });
          const storage = getStorage('items', true);
          if (storage) {
            const findStorage = storage.find((e) => e.username === usuario.Username)
            if (findStorage) {
              setNotifications(findStorage.cantidad);
              setIsView(findStorage.views);
            } else {
              setNotifications(0);
              setIsView(true)
            }
          }
          if (permisos) {
            setDirectivas(permisos.directivas);
            setRecursos(permisos.recursos);
          }
          setIsLogged(true);
        } else {
          logout();
        }
      }
    });
  } else {
    setIsLogged(false);
    navigate("/login");
  }
};

export const logout = () => {
  const email = sessionStorage.getItem("email");
  const userLogin = new AmazonCognitoIdentity.CognitoUser({
    Username: email,
    Pool: userPool,
  });
  if (userLogin) {
    userLogin.signOut();
  }
  sessionStorage.clear();
  navigate("/login");
};
